export const testErrorListConstants = {
  TEST_ERRORS_LOADING: "TEST_ERRORS_LOADING",
  TEST_ERRORS_SUCCESS: "TEST_ERRORS_SUCCESS",
  TEST_ERRORS_FAILURE: "TEST_ERRORS_FAILURE",
};
